module.exports = __webpack_public_path__ + "static/media/no-limit.7e898ede.svg";